import { useContext } from 'react';
import { BlockClipboardContext, IBlockClipboardContextValue } from './BlockClipboardProvider';

/**
 * Accesso agli appunti dei blocchi (F1 copia/incolla): `clipboard` (contenuto
 * copiato o `null`) e `copy(block)`. Usato sia dal kebab della card (scrive)
 * sia dal footer della colonna (legge, per mostrare/nascondere "Incolla").
 *
 * Va chiamato SOLO da un discendente di `BlockClipboardProvider` (montato in
 * AllenamentiPage): l'assenza del Provider è un errore di programmazione, non
 * uno stato valido da assorbire con un fallback silenzioso.
 */
export const useBlockClipboard = (): IBlockClipboardContextValue => {
  const ctx = useContext(BlockClipboardContext);
  if (!ctx) {
    throw new Error('useBlockClipboard va usato dentro <BlockClipboardProvider>');
  }
  return ctx;
};
